// ===== 2E2S WEBSITE CHROME (app-served, versioned) =====
//
// Single in-house source for the site-wide chrome that previously lived in
// the DB "Website Script" record and the Website Settings navbar HTML:
// - the NAVBAR is injected from the template below (one definition for every
//   page; edit here, deploy, done - no DB paste). If the page already
//   contains a .top-navbar (legacy DB navbar still present), injection is
//   skipped so the two never double up.
// - auth panel, user state, logout, /login redirect, protected contact
//   reveal (human-verified) - the chrome behaviors.
// Commerce behaviors (cart, shop cards, stash, Checkify) stay in
// storefront.js. Content archive of the original DB record:
// cutover/website_script.js.

// ── NAVBAR TEMPLATE + INJECTION ─────────────────────────
var E2S_NAVBAR_HTML = "<nav class=\"navbar-custom\">\n    <div class=\"navbar-container\">\n        <div class=\"navbar-main-content\">\n            <div class=\"brand-section\">\n                <a href=\"/\"><img src=\"/assets/e2s/images/srttag.png\" data-fallback=\"/assets/e2s/images/logo.svg\" alt=\"Self Reliance Technology\" class=\"brand-logo\"></a>\n            </div>\n            <div class=\"navbar-menu-section\">\n                <ul class=\"navbar-nav-left\" id=\"nav-menu\">\n                    <li><a class=\"nav-link\" href=\"/shop\" data-page=\"shop\">Shop</a></li>\n                    <li><a class=\"nav-link\" href=\"/learn\" data-page=\"learn\">Learn</a></li>\n                    <li><a class=\"nav-link\" href=\"/e2s\" data-page=\"e2s\">E2S</a></li>\n                </ul>\n            </div>\n            <div class=\"utility-section\">\n                <div class=\"search-wrapper\" id=\"search-area\">\n                    <input type=\"text\" class=\"search-input\" id=\"search-field\" placeholder=\"Search...\">\n                    <i class=\"fa-solid fa-magnifying-glass nav-icon\" id=\"search-icon-trigger\"></i>\n                </div>\n                <a href=\"/stash\" class=\"nav-icon\">\n                    <i class=\"fa-solid fa-cart-shopping\"></i>\n                    <span id=\"cart-count\" class=\"cart-badge\">0</span>\n                </a>\n                <div class=\"user-state-container\" id=\"desktop-logged-in\" style=\"display:none;\">\n                    <div class=\"user-avatar-wrapper\">\n                        <button aria-label=\"Account menu\" class=\"user-avatar\" id=\"desktop-user-avatar-btn\" aria-expanded=\"false\">--</button>\n                        <div class=\"user-dropdown-menu\" id=\"desktop-user-menu\">\n                            <div class=\"dropdown-header-custom\" style=\"padding: 16px 20px 12px 20px;\">\n                                <div style=\"font-size:0.75rem; color:#999; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:4px;\">Welcome</div>\n                                <div class=\"dropdown-user-name\" id=\"desktop-user-name\" style=\"font-weight:600; font-size:15px; color:var(--text-black);\">--</div>\n                            </div>\n                            <div class=\"dropdown-body\">\n                                <a class=\"dropdown-item\" href=\"/castle\"><img src=\"/assets/e2s/images/castle.svg\" style=\"width: 18px; height: 18px; margin-right: 0.5rem; vertical-align: middle;\">My Castle</a>\n                                <a class=\"dropdown-item\" href=\"/e2s\"><img src=\"/assets/e2s/images/favicon.svg\" data-fallback=\"/assets/e2s/images/favicon.png\" style=\"width: 18px; height: 18px; margin-right: 0.5rem; vertical-align: middle;\">E2S</a>\n                                <div class=\"dropdown-divider\"></div>\n                                <a class=\"dropdown-item logout-link\" href=\"/?cmd=web_logout\"><i class=\"fa-solid fa-right-from-bracket me-2\"></i>Logout</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"user-state-container\" id=\"desktop-guest\">\n                    <div class=\"user-avatar-wrapper\">\n                        <button class=\"guest-user-icon\" id=\"desktop-guest-btn\" aria-expanded=\"false\">\n                            <i class=\"fa-solid fa-user\"></i>\n                        </button>\n                        <div class=\"user-dropdown-menu\" id=\"desktop-guest-menu\">\n                            <div class=\"dropdown-header-custom\" style=\"padding: 16px 20px 12px 20px;\">\n                                <div style=\"font-size:0.75rem; color:#999; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:4px;\">Welcome</div>\n                                <div style=\"font-size:0.8rem; color:#888;\">Sign in to your account</div>\n                            </div>\n                            <div class=\"dropdown-body\">\n                                <a class=\"dropdown-item auth-trigger\" href=\"#\" data-tab=\"login\"><i class=\"fa-solid fa-right-to-bracket me-2\"></i>Login</a>\n                                <a class=\"dropdown-item\" href=\"/trial\"><i class=\"fa-solid fa-user-plus me-2\"></i>Create an account</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</nav>\n<div class=\"auth-panel-overlay\" id=\"authOverlay\"></div>\n<div class=\"auth-panel\" id=\"authPanel\">\n    <button class=\"auth-panel-close\" id=\"authPanelClose\">&times;</button>\n    <div class=\"auth-tabs\">\n        <button class=\"auth-tab active\" data-tab=\"login\">Login</button>\n        <button class=\"auth-tab\" data-tab=\"signup\">Create an account</button>\n    </div>\n    <div class=\"auth-message\" id=\"authMessage\"></div>\n    <form class=\"auth-form active\" id=\"loginForm\">\n        <div style=\"margin-bottom: 1rem;\">\n            <label for=\"loginEmail\" style=\"display:block; font-weight:600; margin-bottom:4px;\">Email Address</label>\n            <input type=\"email\" id=\"loginEmail\" name=\"email\" placeholder=\"you@example.com\" required style=\"width:100%; padding:10px 14px; border:2px solid var(--border); border-radius:8px; font-size:1rem; box-sizing:border-box;\">\n        </div>\n        <div style=\"margin-bottom: 1rem;\">\n            <label for=\"loginPassword\" style=\"display:block; font-weight:600; margin-bottom:4px;\">Password</label>\n            <input type=\"password\" id=\"loginPassword\" name=\"password\" placeholder=\"Enter your password\" required style=\"width:100%; padding:10px 14px; border:2px solid var(--border); border-radius:8px; font-size:1rem; box-sizing:border-box;\">\n        </div>\n        <button type=\"submit\" class=\"btn-primary\" id=\"loginSubmit\">Login</button>\n    </form>\n    <form class=\"auth-form\" id=\"signupForm\" style=\"display:none;\">\n        <p style=\"margin-bottom:1rem;\">An account starts with a trial. The trial page says what a trial opens, how long it runs, what we hold about you and when the design data is removed \u2014 all of it before you type anything in.</p>\n        <a class=\"btn-primary\" href=\"/trial\" id=\"signupSubmit\" style=\"display:inline-block; text-decoration:none;\">Go to the trial page</a>\n    </form>\n</div>\n";
var E2S_FOOTER_HTML = "<footer class=\"footer\">\n    <!-- Honeypot \u2014 invisible to humans, irresistible to bots -->\n    <div style=\"position:absolute;left:-9999px;top:-9999px;\" aria-hidden=\"true\">\n        <label for=\"contact-hp\">Leave this empty</label>\n        <input type=\"text\" id=\"contact-hp\" name=\"contact-hp\" tabindex=\"-1\" autocomplete=\"off\">\n    </div>\n    <div class=\"page-container\" style=\"padding-top: 2rem !important;\">\n        <div class=\"contact-content\">\n            <div class=\"row equal-height-columns\">\n                <!-- Contact Us -->\n                <div class=\"col-md-12\">\n                    <div class=\"card\">\n                        <div class=\"card-header\">\n                            <h5>Contact Us to Take Back Your Power</h5>\n                        </div>\n                        <div class=\"card-body\">\n                            <p>We use an extra layer of defense here to block automated harvesters and scammers, ensuring our actual engineering team remains accessible to real people, like you.</p>\n                            <p>\n                                <a href=\"#\" class=\"contact-link\" data-contact=\"phone\">\n                                    <i class=\"fas fa-phone\"></i>\n                                    <span class=\"contact-text\">Loading contact...</span>\n                                </a>\n                            </p>\n                            <p>\n                                <a href=\"#\" class=\"contact-link\" data-contact=\"email\">\n                                    <i class=\"fas fa-envelope\"></i>\n                                    <span class=\"contact-text\">Loading contact...</span>\n                                </a>\n                            </p>\n                            <div class=\"social-section\">\n                                <p><strong>Follow us for sustainability insights:</strong></p>\n                                <div class=\"social-icons\">\n                                    <a href=\"https://x.com/SRT_AU\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"social-icon x\" aria-label=\"X (Twitter)\">\n                                        <img src=\"/assets/e2s/images/square-x-twitter.svg\" alt=\"X\" style=\"width: 100%; height: 100%;\">\n                                    </a>\n                                    <a href=\"https://www.linkedin.com/company/selfreliancetechnology\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"social-icon linkedin\" aria-label=\"LinkedIn\">\n                                        <img src=\"/assets/e2s/images/linkedin.svg\" alt=\"LinkedIn\" style=\"width: 100%; height: 100%;\">\n                                    </a>\n                                    <a href=\"https://www.youtube.com/@SelfRelianceTechnology\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"social-icon youtube\" aria-label=\"YouTube\">\n                                        <img src=\"/assets/e2s/images/square-youtube.svg\" alt=\"YouTube\" style=\"width: 100%; height: 100%;\">\n                                    </a>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <!-- Copyright -->\n                <div class=\"col-md-12\">\n                    <div class=\"card\">\n                        <div class=\"card-body text-center\">\n                            <p>&copy; Copyright. {{E2S_YEAR}} Self Reliance Technology. All rights reserved. ABN 89 642 191 213 </p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</footer>\n";
(function () {
  function inject() {
    // Font Awesome for the website icons - VENDORED in the app and loaded as
    // a proper <link>. The old cdnjs reference was blocked on some networks,
    // which silently erased every icon (navbar search/cart/user, the home
    // page's sector and trust-badge icons).
    if (!document.querySelector('link[href*="fontawesome"], link[href*="font-awesome"]')) {
      var fa = document.createElement('link');
      fa.rel = 'stylesheet';
      fa.href = '/assets/e2s/css/fontawesome/all.min.css';
      document.head.appendChild(fa);
    }
    // Belt-and-braces: the theme CSS hides frappe's structural chrome, but a
    // stale/uncompiled theme must never resurrect the default navbar or the
    // "Powered by ERPNext" footer - remove the nodes outright.
    document.querySelectorAll(
      'nav.navbar:not(.navbar-custom), header > .navbar, footer.web-footer, .footer-powered'
    ).forEach(function (el) { el.remove(); });
    if (!document.querySelector('.top-navbar, .navbar-container')) {
      var host = document.createElement('div');
      host.innerHTML = E2S_NAVBAR_HTML;
      document.body.insertBefore(host, document.body.firstChild);
    }
    if (!document.querySelector('footer.footer')) {
      var foot = document.createElement('div');
      // L15-G5 / L15-F6, 2026-09-14 (r100) — THE YEAR IS READ, NOT WRITTEN.
      // The footer on every page of this site said "© Copyright. 2025" for
      // the whole of 2026: a calendar year in a source literal is wrong from
      // the first of January and nobody notices, because nobody reads their
      // own footer. It is the running year now, and
      // e2s/www/__harness__/www_wording.harness.py §YEAR holds the whole
      // front door to that — no copyright line anywhere in the www tree or
      // in this chrome may carry a year written into the source.
      var year = '';
      try { year = String(new Date().getFullYear()); } catch (e) { year = ''; }
      foot.innerHTML = E2S_FOOTER_HTML.replace('{{E2S_YEAR}}', year);
      document.body.appendChild(foot);
    }
    // brand images fall back to the drawn SVGs if a webp is missing on an
    // older deploy (real listener - inline onerror is CSP-stripped)
    document.querySelectorAll('img[data-fallback]').forEach(function (img) {
      img.addEventListener('error', function () {
        if (img.src.indexOf(img.dataset.fallback) === -1) img.src = img.dataset.fallback;
      });
      if (img.complete && img.naturalWidth === 0) img.src = img.dataset.fallback;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();

// ── REDIRECT /login TO HOMEPAGE WITH AUTH POPUP ─────────────────
(function() {
  var path = window.location.pathname;
  
  if (path === '/login' || path === '/login/') {
    window.location.replace('/?show=login');
  }
  
  if (window.location.search.includes('show=login')) {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(function() {
        var panel = document.getElementById('authPanel');
        var overlay = document.getElementById('authOverlay');
        if (panel && overlay) {
          panel.classList.add('show');
          overlay.classList.add('show');
          var loginTab = document.querySelector('.auth-tab[data-tab="login"]');
          if (loginTab) loginTab.click();
        }
      }, 500);
    });
  }
})();
// ── NAVBAR ────────────────────────
function setupNavbar() {
  try {
    var wrap = document.getElementById('search-area'), icon = document.getElementById('search-icon-trigger'), field = document.getElementById('search-field');
    if (wrap && icon && field) {
      icon.addEventListener('click', function(e) { e.stopPropagation(); if (!wrap.classList.contains('active')) { wrap.classList.add('active'); field.focus(); } else if (field.value.trim()) window.location.href = '/shop?search=' + encodeURIComponent(field.value); else wrap.classList.remove('active'); });
      field.addEventListener('keypress', function(e) { if (e.key === 'Enter' && field.value.trim()) window.location.href = '/shop?search=' + encodeURIComponent(field.value); });
      document.addEventListener('click', function(e) { if (!wrap.contains(e.target)) wrap.classList.remove('active'); });
    }
  } catch(e) { /* the search affordance is chrome: a page whose header does not
    carry it still reads, and the next block still wires the account menu */ }
  try {
    document.body.addEventListener('click', function(e) { var btn = e.target.closest('.guest-user-icon, .user-avatar'); if (!btn) return; e.preventDefault(); e.stopPropagation(); var menu = btn.closest('.user-avatar-wrapper').querySelector('.user-dropdown-menu'); var isOpen = menu.classList.contains('show'); document.querySelectorAll('.user-dropdown-menu.show').forEach(function(m) { m.classList.remove('show'); }); document.querySelectorAll('[aria-expanded="true"]').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); }); if (!isOpen) { menu.classList.add('show'); btn.setAttribute('aria-expanded', 'true'); } });
    document.addEventListener('click', function(e) { if (!e.target.closest('.user-avatar-wrapper')) { document.querySelectorAll('.user-dropdown-menu.show').forEach(function(m) { m.classList.remove('show'); }); document.querySelectorAll('[aria-expanded="true"]').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); }); } });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') { document.querySelectorAll('.user-dropdown-menu.show').forEach(function(m) { m.classList.remove('show'); }); ['authPanel','authOverlay'].forEach(function(id) { var el = document.getElementById(id); if (el) el.classList.remove('show'); }); } });
  } catch(e) { /* account-menu delegation on a page that carries no account
    menu: the header still renders and every link on it still works */ }
}
// ── AUTH PANEL ────────────────────
function setupAuthPanel() {
  try {
    var panel = document.getElementById('authPanel');
    var overlay = document.getElementById('authOverlay');
    if (!panel || !overlay) return;
    var closePanel = function() {
      panel.classList.remove('show');
      overlay.classList.remove('show');
    };
    document.getElementById('authPanelClose').addEventListener('click', closePanel);
    overlay.addEventListener('click', closePanel);
    new MutationObserver(function() {
      if (panel.classList.contains('show')) {
        document.querySelectorAll('.user-dropdown-menu.show').forEach(function(m) { m.classList.remove('show'); });
      }
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });
    document.querySelectorAll('.auth-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        var name = this.getAttribute('data-tab');
        document.querySelectorAll('.auth-tab').forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
        document.getElementById('loginForm').style.display = name === 'login' ? 'block' : 'none';
        document.getElementById('signupForm').style.display = name === 'signup' ? 'block' : 'none';
        document.getElementById('authMessage').innerHTML = '';
      });
    });
    document.getElementById('loginForm').addEventListener('submit', function(e) {
      e.preventDefault();
      var email = document.getElementById('loginEmail').value.trim();
      var pwd = document.getElementById('loginPassword').value;
      var msgEl = document.getElementById('authMessage');
      if (!email || !pwd) {
        /* dignity wording (docs/CLAIMS_POLICY.md), A5a audit 2026-08-30 */
        msgEl.innerHTML = '<span style="color:#c62828;">Both boxes above are still blank.</span>';
        return;
      }
      var btn = document.getElementById('loginSubmit');
      btn.disabled = true;
      btn.textContent = 'Signing in...';
      fetch('/api/method/login', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ usr: email, pwd: pwd })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.message === 'Logged In' || data.home_page) {
          window.location.reload();
        } else {
          /* "Invalid credentials" opens by naming the person's own typing as
             invalid, and a sign-in that did not go through is an event rather
             than a verdict about them (A5a audit 2026-08-30). */
          msgEl.innerHTML = '<span style="color:#c62828;">' + (data.message || "That sign-in didn't go through. The email address and password go together — either one can be the one to check.") + '</span>';
          btn.disabled = false;
          btn.textContent = 'Sign In';
        }
      })
      .catch(function() {
        msgEl.innerHTML = '<span style="color:#c62828;">That didn\'t reach the server — nothing was lost.</span>';
        btn.disabled = false;
        btn.textContent = 'Sign In';
      });
    });
    // L15-F1 (2026-09-14) — THE SIGNUP FORM IS RETIRED, AND WITH IT ITS
    // SUBMIT HANDLER. This posted `frappe.core.doctype.user.user.sign_up`,
    // which lands on `org.apply_signup_dial` and mints a real 30-day trial
    // through `trials.register_self_signup` — whose own docstring says the
    // terms are NOT recorded as accepted on this road "because nobody was
    // shown them … the reason /e2s should point at /trial". One door mints one
    // kind of account now, and it is the one with the terms, the collection
    // note and both periods on it. The panel keeps its `signup` TAB and its
    // `signupForm` element — the wiring above and below reads for both by id
    // and by class — and what they hold is one sentence and the link.
    //
    // AND THE OPENER HAD TO CHANGE WITH THEM, which is the half this comment
    // first got wrong: `openAuthPanel` found its target by `.auth-trigger`,
    // and closing the untermed road removed the last signup trigger, so
    // /stash's [Create Account] pressed nothing at all. It opens the panel off
    // the `.auth-tab` button now — see `window.openAuthPanel` at the foot of
    // this file — so a road that leads somewhere does not depend on a nav
    // control that no longer exists.
    document.querySelectorAll('.auth-trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var tabName = this.getAttribute('data-tab') || 'login';
        panel.classList.add('show');
        overlay.classList.add('show');
        document.querySelectorAll('.auth-tab').forEach(function(t) { t.classList.remove('active'); });
        var targetTab = document.querySelector('.auth-tab[data-tab="' + tabName + '"]');
        if (targetTab) targetTab.classList.add('active');
        document.getElementById('loginForm').style.display = tabName === 'login' ? 'block' : 'none';
        document.getElementById('signupForm').style.display = tabName === 'signup' ? 'block' : 'none';
        document.getElementById('authMessage').innerHTML = '';
      });
    });
  } catch(e) { /* the sign-in panel is wired only on pages that carry it; a page
    without one is not a failure and the rest of the chrome still boots */ }
}
// Redirect /me and /portal to /castle
if (window.location.pathname === '/me' || window.location.pathname === '/portal') {
  window.location.replace('/castle');
}
// ── USER STATE ────────────────────
// Cookie-first: frappe sets user_id/full_name cookies at login on EVERY
// page, while the frappe.session JS object is not reliably populated on
// website pages - relying on it showed logged-in users as guests.
function cookieVal(name) {
  var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : null;
}
function detectUserState() {
  var user = cookieVal('user_id')
    || (typeof frappe !== 'undefined' && frappe.session && frappe.session.user) || null;
  if (!user || user === 'Guest') {
    showGuestState();
    // last resort: ask the server (cookies can be httponly on some builds)
    fetch('/api/method/frappe.auth.get_logged_user', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var u = d && d.message;
        if (u && u !== 'Guest') showLoggedInState(cookieVal('full_name') || u, u, false);
      })
      .catch(function () { /* stay guest */ });
    return;
  }
  var fullName = cookieVal('full_name')
    || (typeof frappe !== 'undefined' && frappe.session && frappe.session.user_fullname)
    || user;
  showLoggedInState(fullName, user, false);
  // best-effort enrichment (proper name casing, desk access) - never
  // required for the logged-in state itself
  fetch('/api/resource/User/' + encodeURIComponent(user), { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(d) {
      var u = d.data || {};
      var better = (u.first_name && u.last_name) ? u.first_name + ' ' + u.last_name
        : (u.first_name || fullName);
      showLoggedInState(better, u.email || user,
        typeof frappe !== 'undefined' && frappe.boot && frappe.boot.desk_access);
    })
    .catch(function() { /* cookie state already shown */ });
}
function getInitials(name) { if (!name || name === '--' || name === 'Guest') { if (typeof frappe !== 'undefined' && frappe.session && frappe.session.user_email) { var en = frappe.session.user_email.split('@')[0]; if (en) return en.charAt(0).toUpperCase(); } return '?'; } var p = name.trim().split(/\s+/); if (p.length >= 2) return (p[0].charAt(0) + p[p.length-1].charAt(0)).toUpperCase(); return name.charAt(0).toUpperCase(); }
function showLoggedInState(name, email, desk) { var ge = document.getElementById('desktop-guest'), le = document.getElementById('desktop-logged-in'); if (ge) ge.style.display = 'none'; if (le) le.style.display = 'flex'; var ini = getInitials(name); var ab = document.getElementById('desktop-user-avatar-btn'), ne = document.getElementById('desktop-user-name'), ee = document.getElementById('desktop-user-email'); if (ab) ab.textContent = ini; if (ne) ne.textContent = name; if (ee) ee.textContent = email; var dl = document.getElementById('desktop-desk-link'); if (dl) dl.style.display = desk ? 'block' : 'none'; }
function showGuestState() { var ge = document.getElementById('desktop-guest'), le = document.getElementById('desktop-logged-in'); if (ge) ge.style.display = 'flex'; if (le) le.style.display = 'none'; }
// the CSRF token frappe expects on a POST: the website bundle's own on a
// marketing page, the E2S shell's embedded one on /e2s (REHOME_SPEC §3)
function signOutToken() {
    try {
        if (typeof frappe !== 'undefined' && frappe && typeof frappe.csrf_token === 'string'
            && frappe.csrf_token) return frappe.csrf_token;
        var b = window.E2S_BOOT;
        if (b && typeof b.csrf_token === 'string') return b.csrf_token;
    } catch (e) { /* no token to read is no header to send */ }
    return '';
}
// END THE SESSION, THEN LAND IN E2S (2026-09-17, REHOME_SPEC round r114).
// Until today this was a GET to /api/method/logout with a GET to
// /?cmd=web_logout as its fallback, and BOTH are refused on this bench:
// the logout doors are POST-only (frappe/handler.py:114-125 at 988e54f) and
// `?cmd=` on a GET is refused (:82-110) — so "Logout" repainted nothing and
// left the person signed in. A POST with the CSRF header is what the
// framework's own sign-out sends; the navigation afterwards shows the person
// the state they are actually in either way.
function signOut() {
    var headers = { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    var token = signOutToken();
    if (token) headers['X-Frappe-CSRF-Token'] = token;
    var land = function () { window.location.href = '/e2s'; };
    return fetch('/api/method/logout', { method: 'POST', credentials: 'same-origin',
        headers: headers })
        .then(land, land);
}
function setupLogout() {
    document.body.addEventListener('click', function(e) {
        var link = e.target.closest('.logout-link');
        if (!link) return;
        e.preventDefault();
        signOut();
    });
}
// ── PROTECTED CONTACT REVEAL (HUMAN-VERIFIED) ─────────────────
var contactRevealed = false;
var contactMouseVerified = false;
var contactTouchVerified = false;
var contactScrollVerified = false;
var contactMousePoints = [];
var contactTouchPoints = [];
var contactLastScrollY = 0;
var contactScrollDirectionChanges = 0;
var contactPageReady = Date.now();
var contactHoneypotClean = true;
(function() {
  var hp = document.getElementById('contact-hp');
  if (hp) {
    if (hp.value.length > 0) contactHoneypotClean = false;
    hp.addEventListener('input', function() { contactHoneypotClean = false; });
  }
})();
document.addEventListener('mousemove', function(e) {
  if (contactMouseVerified || contactRevealed) return;
  contactMousePoints.push({ x: e.clientX, y: e.clientY, t: Date.now() });
  if (contactMousePoints.length > 40) contactMousePoints.shift();
  if (contactMousePoints.length >= 10 && !isLinearPath(contactMousePoints)) {
    contactMouseVerified = true;
    tryReveal();
  }
});
document.addEventListener('touchmove', function(e) {
  if (contactTouchVerified || contactRevealed) return;
  var touch = e.touches[0];
  contactTouchPoints.push({ x: touch.clientX, y: touch.clientY, t: Date.now() });
  if (contactTouchPoints.length > 30) contactTouchPoints.shift();
  if (contactTouchPoints.length >= 10 && !isLinearPath(contactTouchPoints)) {
    contactTouchVerified = true;
    tryReveal();
  }
}, { passive: true });
document.addEventListener('touchstart', function(e) {
  if (contactTouchVerified || contactRevealed) return;
  var touch = e.touches[0];
  if (touch.radiusX && touch.radiusY) {
    var ratio = Math.max(touch.radiusX, touch.radiusY) / Math.min(touch.radiusX, touch.radiusY);
    if (ratio > 1.15) {
      contactTouchVerified = true;
      tryReveal();
    }
  }
}, { passive: true });
window.addEventListener('scroll', function() {
  if (contactScrollVerified || contactRevealed) return;
  var currentY = window.scrollY;
  if (currentY < contactLastScrollY - 20) { contactScrollDirectionChanges++; }
  contactLastScrollY = currentY;
  
  var footer = document.querySelector('footer');
  if (footer) {
    var rect = footer.getBoundingClientRect();
    if (rect.top < window.innerHeight + 200 && contactScrollDirectionChanges >= 2) {
      contactScrollVerified = true;
      tryReveal();
    }
  }
}, { passive: true });
function minTimeElapsed() { return Date.now() - contactPageReady >= 800; }
function isHumanVerified() { return contactMouseVerified || contactTouchVerified || contactScrollVerified; }
function isLinearPath(points) {
  if (points.length < 5) return true;
  var start = points[0], end = points[points.length - 1];
  var dx = end.x - start.x, dy = end.y - start.y;
  var len = Math.sqrt(dx * dx + dy * dy);
  if (len < 15) return true;
  var totalDeviation = 0;
  for (var i = 1; i < points.length - 1; i++) {
    var ex = points[i].x - start.x, ey = points[i].y - start.y;
    totalDeviation += Math.abs(dx * ey - dy * ex) / len;
  }
  return (totalDeviation / (points.length - 2)) < 1.2;
}
function tryReveal() {
  if (contactRevealed) return;
  if (!isHumanVerified()) return;
  if (!contactHoneypotClean) return;
  if (!minTimeElapsed()) { setTimeout(tryReveal, 800); return; }
  revealContacts();
}
// FD-326 (2026-09-24, r136) — THE STORED COPY IS A HINT, NEVER THE ANSWER.
//
// The owner, on r135: "footer is still hello@selfreliance.tech instead of
// welcome@selfreliance.tech". Until today this function read
// sessionStorage['srt_contact'] FIRST and, when anything was there, painted
// it and RETURNED without asking the server — so a browser that revealed the
// footer once before the address changed (2026-09-21, r123) kept painting the
// answer it had stored for the life of that browser session, and the
// server's current answer was never asked. It preferred what it remembered
// over what is true.
//
// Now, after the SAME human-signal gates as before (tryReveal and the click
// fallback are unchanged, and nothing is painted or asked before them):
//   1. a stored copy, if there is one under THIS version's key, is painted at
//      once — a fast first draw, and the copy that survives the gates on a
//      later page;
//   2. the server is ALWAYS asked, and its answer is painted over the hint and
//      stored back;
//   3. a request that fails, or answers with no contact, leaves the hint
//      painted (nothing worse than before) and lets a later gesture ask again.
// The key carries CONTACT_CACHE_VERSION, so a copy stored before this change
// (under the bare 'srt_contact' key) is ignored outright and removed. Bump the
// version whenever a stored copy must never be painted again.
// `contactRevealed` now means "the SERVER's answer is on the page"; painting
// the hint does not set it, so the hint can never short-circuit the request.
// Pinned by e2s/harness_js/__harness__/website_chrome.harness.mjs §REVEAL.
var CONTACT_CACHE_VERSION = 2;
var CONTACT_CACHE_KEY = 'srt_contact:v' + CONTACT_CACHE_VERSION;
var CONTACT_CACHE_RETIRED = ['srt_contact'];
var contactAsking = false;
function readContactHint() {
  try {
    CONTACT_CACHE_RETIRED.forEach(function(k) { sessionStorage.removeItem(k); });
  } catch(e) { /* storage refused: the retired copy is never READ either way,
    so leaving it in place costs nothing */ }
  try {
    var stored = JSON.parse(sessionStorage.getItem(CONTACT_CACHE_KEY) || 'null');
    if (!stored || stored.v !== CONTACT_CACHE_VERSION || !stored.data) return null;
    return (stored.data.phone || stored.data.email) ? stored.data : null;
  } catch(e) { return null; /* an unreadable copy is no copy: the server is asked regardless */ }
}
function storeContactHint(data) {
  try {
    sessionStorage.setItem(CONTACT_CACHE_KEY, JSON.stringify({ v: CONTACT_CACHE_VERSION, data: data }));
  } catch(e) { /* best-effort hint: storage refused means the next page asks the server with nothing painted first */ }
}
function revealContacts() {
  if (contactRevealed || contactAsking) return;
  var hint = readContactHint();
  if (hint) populateContactLinks(hint);
  contactAsking = true;
  fetch('/api/method/e2s.api.commerce.customer.get_contact_details', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(d) {
      contactAsking = false;
      var data = (d && d.message) || d || {};
      if (data.phone || data.email) {
        contactRevealed = true;
        storeContactHint(data);
        populateContactLinks(data);
      }
      // otherwise the endpoint was reachable but returned no contact (a paced
      // refusal, a 404 JSON body with no .message): whatever is painted stays
      // — the hint, or "Loading contact..." — and contactRevealed stays false
      // so a click or a later gesture asks again.
    })
    .catch(function() { contactAsking = false; /* the hint, if any, stays painted; a later gesture asks again */ });
}
function populateContactLinks(data) {
  // `data-contact-shown` marks a link already painted, so the server's answer
  // can repaint a link the hint painted a moment earlier. A link the answer
  // has no value for keeps `data-contact`, so a later answer can still find it.
  ['phone', 'email'].forEach(function(kind) {
    document.querySelectorAll('[data-contact="' + kind + '"], [data-contact-shown="' + kind + '"]').forEach(function(el) {
      var value = data[kind];
      if (value) {
        el.href = kind === 'phone' ? 'tel:' + value.replace(/\s/g, '') : 'mailto:' + value;
        var text = el.querySelector('.contact-text');
        if (text) text.textContent = value;
        el.setAttribute('data-contact-shown', kind);
        el.removeAttribute('data-contact');
      }
    });
  });
}
function setupContactClickFallback() {
  document.querySelectorAll('.contact-link[data-contact]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      // a link that carries a real address (tel:/mailto:) is followed; the
      // click is taken only while it still says "Loading contact..."
      if (link.getAttribute('data-contact-shown')) return;
      e.preventDefault();
      if (!contactRevealed) { contactMouseVerified = true; revealContacts(); }
    });
  });
}
function setupFooterReveal() {
  setupContactClickFallback();
}
function scrollToFooter() {
  var footer = document.querySelector('footer');
  if (footer) { footer.scrollIntoView({ behavior: 'smooth' }); }
  else { window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' }); }
}

// bundling wraps this file in a module scope: expose what pages and
// storefront.js reach for, and delegate the footer-scroll CTAs
window.scrollToFooter = scrollToFooter;
// L15-F1 (2026-09-14) — THE OPENER NO LONGER DEPENDS ON A NAV TRIGGER EXISTING.
//
// It found its target by `.auth-trigger[data-tab="…"]` and clicked it, which
// worked only while every tab had a trigger somewhere in the chrome. Closing
// the untermed signup road removed the last two `data-tab="signup"` triggers,
// and that turned /stash's [Create Account] (storefront.bundle.js →
// `openAuthPanel('signup')`) into a silent no-op: this function is DEFINED, so
// storefront's own `/login` fallback — which only fires when it is not — never
// ran. A door that does nothing at all is worse than the door that was closed.
//
// So the panel is opened DIRECTLY, off the thing that is always in the panel:
// the `.auth-tab` button. The trigger is still tried first, because a page
// carrying one gets exactly the behaviour it had. Then the tab button, which
// carries the panel's own open/select wiring. And if the chrome is not on this
// page at all, the trial page is where an account starts — the same one door
// every other signup road now points at, so the last resort is a real place
// rather than a dead press.
window.openAuthPanel = function (tab) {
  var want = tab || 'login';
  var trigger = document.querySelector('.auth-trigger[data-tab="' + want + '"]');
  if (trigger) { trigger.click(); return; }
  var button = document.querySelector('.auth-tab[data-tab="' + want + '"]');
  var panel = document.getElementById('authPanel');
  var overlay = document.getElementById('authOverlay');
  if (button && panel) {
    panel.classList.add('show');
    if (overlay) overlay.classList.add('show');
    button.click();
    return;
  }
  window.location.href = '/trial';
};
document.addEventListener('click', function (e) {
  var link = e.target.closest('.js-scroll-footer');
  if (!link) return;
  e.preventDefault();
  scrollToFooter();
});

// ── INIT (chrome only - commerce init lives in storefront.js) ───
document.addEventListener('DOMContentLoaded', function() {
  contactPageReady = Date.now();
  // one setup per try, deliberately: these six are INDEPENDENT pieces of page
  // chrome, and a page that carries only some of them must still get the ones
  // it does carry. Each swallow is "this piece is not on this page", never a
  // dropped write — none of them records anything.
  try { setupContactClickFallback(); } catch(e) { /* see above */ }
  try { setupNavbar(); } catch(e) { /* see above */ }
  try { setupAuthPanel(); } catch(e) { /* see above */ }
  try { setupLogout(); } catch(e) { /* see above */ }
  try { detectUserState(); } catch(e) { /* see above */ }
  try { setupFooterReveal(); } catch(e) { /* see above */ }
});
